import { Text } from "@dna/react";
import React from "react";
import { FilterStatus } from "./resident-filter/FilterStatus";
import { ChartStatusFilter } from "../../services/medicationmanagement/patientApi/models/ChartStatusFilter";
import { ExpiryFilterType } from "../../services/medicationmanagement/patientApi/models/ExpiryFilterType";


const filterstatusTitle = (status: number) => {
    if (status > 0) {
        if (status === FilterStatus.Active) {
            return "All Active residents";
        }
        else if (status === FilterStatus.Discharged) {
            return "All Discharged residents"
        }
        else if (status === FilterStatus.Deceased) {
            return "All Deceased residents"
        }
    
    }
    return "All residents";
}

const withExpiryFilter=(chartExpiry?:ExpiryFilterType)=>{
    return (message:string)=> {
        if (!chartExpiry) {
            return message;
        }
        switch (chartExpiry) {
            case ExpiryFilterType.All:
                return message;
            case ExpiryFilterType.ChartDueNowOrSoon:
                return `${message} with charts expiring/expired`;
            case ExpiryFilterType.CourseDueNowOrSoon:
                return `${message} with courses expiring/expired`;
        }
    }
};

const withChartStatus=(chartStatus?:ChartStatusFilter)=>{
    return (message:string)=> {
        if (!chartStatus) {
            return message;
        }
        switch (chartStatus) {
            case ChartStatusFilter.All:
                return message;
            case ChartStatusFilter.WithChanges:
                return `${message} with changes`;

        }
    }
};

export function ResidentListHeader(props:{
    name:string,
    resultSize:number|null|undefined,
    total:number;residentStatus:FilterStatus,
    expiryFilterType: ExpiryFilterType,
    chartStatus?:ChartStatusFilter
}){
    let {name,resultSize,total,residentStatus}=props;
    let chartExpiryHeaderCreator = withExpiryFilter(props.expiryFilterType);
    let chartStatusHeaderCreator = withChartStatus(props.chartStatus); 
    let header:string = chartStatusHeaderCreator(chartExpiryHeaderCreator(filterstatusTitle(residentStatus)));

    if (name) {
        header = `${header} matching "${name}"`;
    }

    if (resultSize) {
        header = `${header} (${resultSize||0} of ${total||0})`;
    }
   
    return (<Text level="medium" as="strong">
        {header}
    </Text>);
}